import React, { useState } from 'react';
import { apiCall } from '../../services/authServieces';
import '../../css/BucketFileUrlPage.css'

function BucketFileCheck() {
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [files, setFiles] = useState([]);

    const fetchDataFile = async () => {

        if (!fromDate && !toDate){
            alert("Please Select FromDate And ToDate")

        return ;
        }
        try {
            let response = await apiCall({
                endpoint: `admin/getfileUrl?fromDate=${fromDate}&toDate=${toDate}`,
                method: "GET"
            });

            if (response.success) {
                setFiles(response.FileUrl);
            }
        } catch (error) {
           alert(error?.response?.data?.message);
        }
    };

    const downloadFile = (url) => {
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="bucketfilecheck__container">
            <h2 className="bucketfilecheck__title">PDSA Bucket File Checker</h2>

            <div className="bucketfilecheck__filters">
                <div className="bucketfilecheck__inputgroup">
                    <label htmlFor="fromDate" className="bucketfilecheck__label">From Date</label>
                    <input
                        id="fromDate"
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                        className="bucketfilecheck__input"
                    />
                </div>
                <div className="bucketfilecheck__inputgroup">
                    <label htmlFor="toDate" className="bucketfilecheck__label">To Date</label>
                    <input
                        id="toDate"
                        type="date"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        className="bucketfilecheck__input"
                    />
                </div>
                <button className="bucketfilecheck__button" onClick={fetchDataFile}>Search</button>
            </div>

            <div className="bucketfilecheck__results">
                {files.length > 0 ? (
                    files.map((file, index) => (
                        <div key={index} className="bucketfilecheck__fileitem">
                            <span className="bucketfilecheck__filename">{file.bucketFile.split('/').pop()}</span>
                            <button
                                className="bucketfilecheck__download"
                                onClick={() => downloadFile(file.bucketFile)}
                            >
                                Download
                            </button>
                        </div>
                    ))
                ) : (
                    <p className="bucketfilecheck__nofile">No files found</p>
                )}
            </div>
        </div>
    );
}

export default BucketFileCheck;
